import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Isvg from 'react-inlinesvg';
import moveIcon from '../../assets/svg/move.svg';
import moreIcon from '../../assets/svg/more.svg';

import arrowDown from '../../assets/svg/arrow-down.svg'
import arrowUp from '../../assets/svg/arrow-up.svg'

import moment from 'moment';
import { API_ENDPOINT } from '../../constants';
import ErrorModal_v2 from '../../components/errorModal_v2';
import ScheduleSlot from './scheduleEventHelper/scheduleSlot';
import ScheduleControl from './scheduleEventHelper/scheduleControl';
import PatientModal from './scheduleEventHelper/patientModal';
import ScheduleReferral from './scheduleEventHelper/scheduleReferral';
import AddNewAdministrativeBookingButton from './administrativeBookings/addNewAdministrativeBookingButton';

function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}


class ScheduleEventModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            availabilityTemplates: []
        }
    }



    setInitialData = () => {
        this.fetchAvailabilityTemplates();
    }
    fetchAvailabilityTemplates = () => {
        this.setState({ availabilityTemplates: [] }, () => {
            fetch(API_ENDPOINT + '/data/availability-templates/data/fetch', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    userId: this.props.uData?._id,
                    groupId: this.props.selectedGroup,
                    clinicId: this.props.selectedClinic
                })
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.items?.length) {
                    this.setState({ availabilityTemplates: result.items })
                }
            })
        })
    }



    componentDidMount() {
        this.setInitialData();


    }
    componentDidUpdate(prevProps, prevState) {


    }
    componentWillUnmount() {

    }

    toggle = (notFetchItems = false, callback = null) => {
        if (this.props.toggle) {
            this.props.toggle(notFetchItems, callback);
        }
    }
    formatDate = (date, format) => {
        if (!date || !format) return '';
        let dateString = date?.split(' ')?.[0];
        let timeString = date?.split(' ')?.[1];

        let DD = dateString?.split('/')[1];
        let MM = dateString?.split('/')[0];
        let YYYY = dateString?.split('/')[2];
        let HH = timeString?.split(':')[0];
        let mm = timeString?.split(':')[1];

        let formattedDate = format
            .replace('DD', DD)
            .replace('MM', MM)
            .replace('YYYY', YYYY)
            .replace('HH', HH)
            .replace('mm', mm);

        return formattedDate;

    }


    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        let groupData = this.props?.uData?.clinicGroups?.[selectedGroupIdx];

        return groupData;
    }
    generateInitialTime = () => {
        let tsNow = Math.floor(new Date().getTime() / 1000);
        const interval = 10 * 60;
        const ts = Math.ceil(tsNow / interval) * interval;

        let date = moment.unix(ts).format(this.props.dateFormat);
        let startTime = moment.unix(ts).format('HH:mm');
        let endTime = moment.unix(ts + 60 * 5).format('HH:mm');

        let data = {
            date,
            endDate: date,
            startTime,
            endTime,
            title: ''
        }

        return data;
    }

    render() {

        const isOpen = this.props.isOpen ? true : false;
        if (!isOpen) return null;

        const scheduleModalOpen = this.state.scheduleType ? false : true;

        const groupData = this.getGroupData();

        const visitTemplates = groupData?.visitTemplates ?? null;
        const availabilityTemplatesEnabled = this.state.availabilityTemplates?.length && visitTemplates ? true : false;
        const administrativeBookingsEnabled = true; // groupData?.administrativeBookings ? true : false;
        const initialTime = this.generateInitialTime();

        return (
            <>
                <Modal isOpen={scheduleModalOpen} centered>
                    <ModalHeader
                        toggle={() => this.setState({ scheduleType: null }, () => this.toggle(true))}
                        close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ scheduleType: null }, () => this.toggle(true))}>&times;</button>}>
                        {'Select the way to schedule'.translate(this.props.lang)}
                    </ModalHeader>

                    <ModalBody>
                        <div className='schedule-modal-body-wrap'>
                            <Button color='primary'
                                onClick={() => {
                                    let setObj = {};
                                    setObj.scheduleType = 'event';
                                    setObj.schedulePatientTime = { ...initialTime, type: 'event' };
                                    this.setState(setObj)
                                }}
                            >
                                {'Schedule event'.translate(this.props.lang)}
                            </Button>
                            <Button color='primary'
                                onClick={() => {
                                    let setObj = {};
                                    setObj.scheduleType = 'free';
                                    setObj.schedulePatientTime = { ...initialTime, type: 'free' };
                                    this.setState(setObj)
                                }}
                            >
                                {'Mark as available'.translate(this.props.lang)}
                            </Button>
                            {
                                availabilityTemplatesEnabled ?
                                    <Button color='primary'
                                        onClick={() => {
                                            let setObj = {};
                                            setObj.scheduleType = 'template';
                                            setObj.schedulePatientTime = { ...initialTime, type: 'template' };
                                            this.setState(setObj)
                                        }}
                                    >
                                        {'Add availability template'.translate(this.props.lang)}
                                    </Button>
                                    :
                                    null
                            }
                            <Button
                                color='primary'
                                onClick={() => {
                                    this.setState({
                                        scheduleNewVisitDropdown: !this.state.scheduleNewVisitDropdown
                                    })
                                }}
                                className='schedule-new-visit-dropdown-btn'
                                style={this.state.scheduleNewVisitDropdown ? { marginBottom: 3 } : {}}
                            >
                                {'Schedule new visit'.translate(this.props.lang)}
                                <Isvg
                                    src={this.state.scheduleNewVisitDropdown ? arrowUp : arrowDown}
                                    style={{ marginTop: this.state.scheduleNewVisitDropdown ? 5 : -5 }}
                                />
                            </Button>
                            {
                                this.state.scheduleNewVisitDropdown ?
                                    <div className='schedule-new-visit-dropdown-wrap'>
                                        <Button color='primary'
                                            onClick={() => {
                                                //     if (!this.state.referralsFetched) {
                                                //         this.getAllReferrals()
                                                //     }
                                                let setObj = {};
                                                setObj.scheduleType = 'revisit';
                                                setObj.scheduleControl = { ...initialTime };
                                                this.setState(setObj)
                                            }}
                                        >
                                            {/* {'Schedule a new visit / revisit'.translate(this.props.lang)} */}
                                            {'New visit / revisit'.translate(this.props.lang)}
                                        </Button>
                                        <Button color='primary'
                                            onClick={() => {
                                                //     if (!this.state.referralsFetched) {
                                                //         this.getAllReferrals()
                                                //     }
                                                let setObj = {};
                                                setObj.scheduleType = 'referral';
                                                setObj.scheduleReferral = { ...initialTime };
                                                this.setState(setObj)
                                            }}
                                        >
                                            {/* {'Schedule approved case'.translate(this.props.lang)} */}
                                            {'Approved / canceled visit'.translate(this.props.lang)}
                                        </Button>

                                        {
                                            administrativeBookingsEnabled ?
                                                <AddNewAdministrativeBookingButton
                                                    {...this.props}
                                                    initialData={{ ...initialTime, type: 'administrativeBooking' }}
                                                    // doctorId={this.props?.uData?._id}
                                                    // toggle={() => {
                                                    //     this.setState({ scheduleModal: !this.state.scheduleModal, doctorsList: [] })
                                                    //     this.get();
                                                    // }}
                                                    toggle={() => this.toggle()}
                                                />
                                                :
                                                null
                                        }
                                    </div>
                                    :
                                    null
                            }


                        </div>

                    </ModalBody>
                </Modal>

                {
                    this.state.schedulePatientTime ?
                        <ScheduleSlot
                            {...this.props}
                            isOpen={this.state.schedulePatientTime}
                            availabilityTemplatesEnabled={availabilityTemplatesEnabled}
                            toggle={(notFetchItems = false, callback = null) => {
                                this.setState({ schedulePatientTime: null }, () => {
                                    if (callback) callback?.();
                                    this.toggle(notFetchItems, callback);
                                })
                            }}
                        />
                        : null
                }


                {
                    this.state.patientModal ?
                        <PatientModal
                            {...this.props}
                            isOpen={this.state.patientModal}
                            toggle={(notToggle = false) => this.setState({ patientModal: false }, () => {
                                if (!notToggle) {
                                    this.toggle(true);
                                }
                            })}
                            setData={(data, callback) => {
                                if (data?.patient) {
                                    this.setState({ scheduleControl: { ...data } }, () => {
                                        if (callback) {
                                            callback?.();
                                        }
                                    })
                                }
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.scheduleControl ?
                        <ScheduleControl
                            {...this.props}
                            isOpen={this.state.scheduleControl}
                            toggle={(notToggle = false) => this.setState({ scheduleControl: false }, () => {
                                if (!notToggle) {
                                    this.toggle(true);
                                }
                            })}
                            findPatient={(data, callback) => {
                                this.setState({ patientModal: data, scheduleControl: false }, () => {

                                    if (callback) {
                                        callback();
                                    }
                                })
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.scheduleReferral ?
                        <ScheduleReferral
                            {...this.props}
                            isOpen={this.state.scheduleReferral}
                            toggle={(notToggle = false, notFetchItems = false) => this.setState({ scheduleReferral: false }, () => {
                                if (!notToggle) {
                                    this.toggle(notFetchItems);
                                }
                            })}

                        />
                        :
                        null
                }


            </>


        )
    }
}

export default ScheduleEventModal;